var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-card', { staticClass: "chart-card" }, [_c('div', { staticClass: "chart-container" }, [_c('div', { staticClass: "data-source-switcher" }, [_vm._t("default")], 2), _vm._v(" "), _c('v-chart', { ref: "echarts", attrs: { "options": _vm.computedOptions, "autoresize": true } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };